import { Row, Space } from 'antd'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import Form from 'app/components/Core/Rental/Form'
import KButton from 'app/components/Modules/General/KButton'
import Container from 'app/components/UI-Elements/Layout/Container'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import KFooter from 'app/components/UI-Elements/Layout/KFooter'
import { RecordType } from 'app/constants/GlobalTypes'
import rentalNormalizer from 'app/lib/apollo/normalizers/Rental'
import { useBrowserRouterContext } from 'app/lib/contexts/KBrowserRouter'
import { useQuery } from 'app/lib/hooks/useQuery'
import useSetBackHistory from 'app/lib/hooks/useSetBackHistory'
import useTitle from 'app/lib/hooks/useTitle'
import { PageProps } from 'app/pages/typing'
import * as rentalsCheckout from 'app/queries/Rentals/Checkout'
import { Routes } from 'app/routes/Routes'
import * as React from 'react'
import { useParams } from 'react-router-dom'

import CheckoutStepper from '../Component/Stepper'

const portalId = 'project-kfooter-submit'

const CheckoutDelivery: React.FC<PageProps> = (props) => {
  useTitle(props)
  const { setBackRoute, goBack } = useBrowserRouterContext()
  const { checkout_id: rental_id } = useParams<{ checkout_id: string }>()
  const {
    data: { rental },
    loading
  } = useQuery<{ rental: IRental }>(rentalsCheckout.RENTAL_CHECKOUT_QUERY, {
    variables: {
      id: rental_id
    },
    normalizer: (data) => ({ rental: rentalNormalizer(data.rental) })
  })
  const { md } = useBreakpoint()

  useSetBackHistory(() => {
    setBackRoute(Routes.Checkout.member(rental_id).machines)
  })

  return (
    <Container loading={!rental}>
      <If condition={rental}>
        <Row gutter={[{ md: 24, xs: 0 }, 24]}>
          <KCol span={24}>
            <CheckoutStepper activeStep={2} />
          </KCol>
          <KCol span={24} loading={!rental}>
            <Form member={rental} props={{ portalId, loading }} />
          </KCol>
        </Row>
      </If>
      <KFooter sticky={!md} removePadding={md}>
        <Space>
          <If condition={md}>
            <KButton
              type="secondary"
              onClick={goBack}
              recordType={RecordType.checkout}
              action="back_to_machines"
            />
          </If>
          <div id={portalId} />
        </Space>
      </KFooter>
    </Container>
  )
}

export default CheckoutDelivery
